import Recsys from './recsys';

export default Recsys;
